module.exports = __webpack_public_path__ + "static/media/verchitos.45a30609.jpg";